export const housekeeping = {
  // ── Page (index) ──
  title: "Pulizie",
  remindersBtn: "Promemoria",
  refresh: "Aggiorna",
  aboutToLeaveTitle: "Ospiti in partenza oggi",
  aboutToLeaveCount: "{count} in partenza",
  remindersTitle: "Configura i promemoria di pulizia",

  headline: {
    allDone: "Tutto in ordine! Niente da pulire al momento.",
    inProgress: "Pulizie in corso · {count} in lavorazione",
    toClean: "Cosa c'è da pulire oggi? {count} da pulire",
    toCleanWithProgress: "Cosa c'è da pulire oggi? {toClean} da pulire · {inProgress} in lavorazione",
  },

  allProperties: "Tutte le strutture",
  searchPlaceholder: "Cerca camera, ospite…",

  // Status filter chips (label)
  chips: {
    all: "Tutte",
    to_clean: "Da pulire",
    in_progress: "In corso",
    occupied: "Occupata",
    clean: "Disponibile",
    out_of_service: "Fuori servizio",
  },
  // Status filter chips (tooltip)
  chipTips: {
    all: "Tutti gli spazi di oggi, senza filtri.",
    to_clean: "Pulizia in sospeso: contrassegnate come sporche, in partenza oggi e non pulite, o soggiorni lunghi in scadenza secondo l'intervallo previsto.",
    in_progress: "Pulizia in corso in questo momento.",
    occupied: "Ospite all'interno (soggiorno in corso, non in partenza oggi).",
    clean: "Pulita e pronta per il prossimo ospite (incluse quelle ispezionate).",
    out_of_service: "Non disponibile per la pulizia (guasto o manutenzione).",
  },

  loadingBoard: "Caricamento bacheca…",
  emptyToClean: "Tutto pulito! Nessuno spazio in sospeso al momento.",
  emptyStatus: "Nessuno spazio in questo stato.",
  emptySearch: "Nessuno spazio corrisponde alla ricerca.",

  typeHotel: "Hotel",
  typeApartment: "Appartamento",

  // Row badges
  stayDue: "Pulizia in scadenza",
  hourlyStayDue: "Uscita a ore",
  hourlyStayAt: "Uscito alle {time}",
  overdue: "In ritardo",
  overdueSince: "Non pulita dal {date} · {days} giorni",
  overdueGuests: "{n} ospiti se ne sono andati senza pulizia registrata",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "Dalle {from} alle {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Orario superato",
  alreadyLeft: "Già partito",
  aboutToLeave: "In partenza",
  cleanBadge: "Pulita",
  inspectedBadge: "Ispezionata",

  // Turnover (one leaves / another arrives)
  departs: "↑ Uscita",
  arrives: "↓ Entrata",
  guestFallback: "Ospite",
  departsOn: "· parte il {date}",

  // Row actions
  assign: "Assegna",
  reassignTitle: "Riassegna chi pulisce",
  assignWhoTitle: "Assegna chi pulisce",
  start: "Avvia",
  startTitle: "Segna come in corso",
  cleanAction: "Pulisci",
  cleanTitle: "Completa la pulizia (foto e note)",
  tasks: "Attività",
  tasksTitle: "Attività e dettagli",

  toastSaved: "Promemoria di pulizia aggiornati",

  // Effective status (label)
  status: {
    to_clean: "Da pulire",
    in_progress: "In corso",
    occupied: "In uso",
    clean: "Disponibile",
    inspected: "Ispezionata",
    out_of_service: "Fuori servizio",
  },
  // Effective status (tooltip)
  statusTip: {
    to_clean: "In attesa di essere pulita.",
    in_progress: "Pulizia in corso.",
    occupied: "In uso: ospite all'interno.",
    clean: "Pulita e pronta per il prossimo ospite.",
    inspected: "Pulita e verificata da un supervisore.",
    out_of_service: "Fuori servizio: non può essere pulita (guasto/manutenzione).",
  },
  // Occupancy (label)
  occupancy: {
    vacant: "Libera",
    occupied: "Occupata",
    departure_today: "Partenza oggi",
    arrival_today: "Arrivo oggi",
    turnover: "Partenza e arrivo",
  },
  // Occupancy (tooltip)
  occupancyTip: {
    vacant: "Nessun ospite: libera.",
    occupied: "Ospite all'interno (soggiorno in corso).",
    departure_today: "L'ospite parte oggi: sarà da pulire.",
    arrival_today: "Oggi arriva un ospite: deve essere pronta in tempo.",
    turnover: "Oggi un ospite parte e un altro arriva: pulizia urgente nel mezzo.",
  },

  roles: {
    limpieza: "Pulizie",
    mantenimiento: "Manutenzione",
    recepcion: "Reception",
    gestor: "Gestore",
    propietario: "Proprietario",
  },

  // Mid-stay cleaning reason
  stayTip: {
    fallback: "Pulizia del soggiorno in scadenza",
    daysSince: "{count} giorno | {count} giorni",
    interval: "ogni giorno | ogni {count} giorni",
    main: "L'ospite è ancora in soggiorno. È da {since} che non viene fatta la pulizia e va effettuata {interval}.",
  },

  // Cleaning-window timer
  timer: {
    approx: " (circa)",
    overdue: "Arrivo in ritardo",
    overdueTitle: "L'orario di arrivo ({checkin}) è passato · dai priorità a questa pulizia",
    remaining: "{dur} all'arrivo",
    remainingTitle: "Mancano {dur} all'arrivo ({checkin})",
  },

  // ── Reminders modal ──
  remind: {
    title: "Promemoria di pulizia",
    subtitle: "Avvisa il tuo team quando una camera con un arrivo/partenza imminente non è pronta.",
    close: "Chiudi",
    scopeLabel: "Quali strutture?",
    scopeOne: "Questa struttura",
    scopeAll: "Tutte",
    summary: "{enabled} di {total} strutture con promemoria attivi.",
    propertyLabel: "Struttura",
    activeSuffix: " · attivo",
    propertyHelp: "Ogni struttura mantiene la propria pianificazione.",
    allNotePre: "Le stesse impostazioni si applicheranno alle tue ",
    allNotePost: " strutture (ciascuna nel proprio orario locale).",
    arrivalsTitle: "Arrivi e partenze",
    longStayTitle: "Prenotazioni di lungo soggiorno",
    daysBeforeLabel: "Con quanto anticipo?",
    daysBefore: {
      same: "Solo lo stesso giorno",
      upTo: "Fino a {count} giorno prima | Fino a {count} giorni prima",
    },
    daysBeforeHelp: "Considera gli arrivi/partenze entro questo intervallo.",
    intervalLabel: "Quanti giorni tra una pulizia e l'altra?",
    interval: "Ogni giorno | Ogni {count} giorni",
    intervalHelp: "Conteggiati dall'ultima pulizia. La camera comparirà in 'Da pulire' anche se ancora occupata.",
    timeLabel: "A che ora vengono inviati?",
    timeHelp: "Orario locale della struttura. Una volta al giorno.",
    recipientsLabel: "Chi viene avvisato?",
    note: "Vengono inviati tramite una coda (notifica + push) e ogni avviso viene registrato nelle notifiche.",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveAll: "Salva per tutte",
    save: "Salva",
    recipients: {
      assigned: "Assegnati",
      team: "Team",
      both: "Entrambi",
    },
    recipientHelp: {
      assigned: "Solo le persone assegnate a quella camera.",
      team: "L'intero team di pulizia/manutenzione della struttura.",
      both: "Gli assegnatari e il team della struttura.",
    },
    longStayOff: "Disattivato",
    longStaySub: "Ogni giorno del soggiorno | Ogni {count} giorni del soggiorno",
    toggleAllOn: "Sarà attivato per tutte",
    toggleAllOff: "Sarà disattivato per tutte",
    toggleOneOn: "Attivato per questa struttura",
    toggleOneOff: "Disattivato",
  },

  // ── Complete-cleaning modal ──
  complete: {
    title: "Completa la pulizia",
    dropStrong: "Trascina le foto qui",
    dropRest: "o clicca per selezionare",
    dropHint: "Prove dello stato della camera · JPG, PNG, WEBP",
    photoAlt: "foto",
    saved: "Salvata",
    view: "Visualizza",
    remove: "Rimuovi",
    notes: "Note",
    notesPlaceholder: "Problemi, danni, oggetti mancanti… (opzionale)",
    cancel: "Annulla",
    uploading: "Caricamento… {pct}%",
    saving: "Salvataggio…",
    submit: "Segna come pulita",
    previewAlt: "anteprima",
  },

  // ── Assign modal ──
  assignModal: {
    title: "Chi pulisce questo spazio?",
    allOption: "Tutti",
    allDesc: "Visibile a tutto il personale di pulizia e manutenzione",
    roleSection: "Assegna a un ruolo",
    peopleTitle: "Oppure scegli le persone",
    peopleHint: "(una o più)",
    emptyPre: "Non hai ancora membri del team. Puoi assegnare per ruolo oppure aggiungere persone in ",
    emptyTeam: "Team",
    emptyPost: ".",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva assegnazione",
  },

  // ── Pianificazione: il calendario delle pulizie future ──
  plan: {
    title: "Pianificazione delle pulizie",
    viewToday: "Oggi",
    viewPlan: "Pianificazione",
    loading: "Caricamento del calendario…",
    loadError: "Non è stato possibile caricare il calendario.",
    saveError: "Non è stato possibile salvare. Riprova.",
    empty: "Nessuna pulizia in queste date.",
    space: "Spazio",
    prev: "Giorni precedenti",
    next: "Giorni successivi",
    today: "Oggi",
    days: "{n} giorni",
    anyone: "Chiunque",
    unassigned: "Non assegnate",
    headline: {
      nothing: "Non c'è nulla in sospeso in queste date.",
      all: "{total} pulizie in sospeso · {urgentes} urgenti",
      withOrphans: "{total} in sospeso · {urgentes} urgenti · {sin} non assegnate",
    },
    types: {
      turnover: "Esce ed entra",
      arrastre: "In ritardo",
      salida: "Partenza",
      estancia: "Soggiorno lungo",
      manual: "Segnata a mano",
    },
    abbr: { all: "TUT", turnover: "TURN", arrastre: "RIT", salida: "PART", estancia: "SOG", manual: "MAN" },
    windowGuessed: "Orari di default: questo alloggio non ha i suoi",
    legendTight: "Margine ristretto tra partenza e arrivo",
    noRoomTip: "{n} partenze senza camera ancora assegnata",
    windowTip: "Tra la partenza ({desde}) e l'arrivo ({hasta}) ci sono {min} minuti",
    roleShort: "RUOLO",
    roleFull: "Assegnata a un ruolo, non a una persona",
    fromSpace: "assegnazione fissa dello spazio",
    nobody: "Non assegnata — clicca per scegliere qualcuno",
    dow: { mon: "L", tue: "M", wed: "M", thu: "G", fri: "V", sat: "S", sun: "D" },

    teamRows: "Carico della squadra",

    teamTitle: "Squadra",
    capacity: "Capacità",
    capacityTitle: "Quante pulizie riesce a fare ogni persona al giorno",
    done: "Fatto",
    perDay: "Al giorno",
    dayOffTip: "Segna come giorno libero",
    noStaff: "Non hai ancora personale di pulizia. Aggiungi persone in Squadra e qui vedrai il loro carico.",
    shortHands: "Mancano braccia: {dias}",
    loadTip: "{dia}: {n} su {cap}",
    loadTipOff: "{dia}: giorno libero ({n} assegnate)",
    hasNow: "{n} assegnate · regge {cap} al giorno",

    selected: "{n} selezionate",
    assignTo: "Assegna a…",
    assignBtn: "Assegna {n}",
    people: "Persone",
    noteTitle: "Nota per questa pulizia",
    notePlaceholder: "Arriva tardi, dai priorità…",
    unassign: "Rimuovi",
    clear: "Deseleziona",
    assigned: "{n} pulizie assegnate",
    unassigned2: "Assegnazione rimossa",
    partial: "{n} assegnate, {mal} non è stato possibile",
    autoAssign: "Distribuisci automaticamente",
    nothingToAssign: "Non c'è nulla non assegnato in queste date.",
    proposalTitle: "Proposta di distribuzione",
    proposalSub: "{n} pulizie distribuite. Controlla prima di applicare.",
    proposalApply: "Applica la distribuzione",
    proposalUncovered: "{n} non coperte",
    cancel: "Annulla",
    uncovered: {
      nadie_tiene_esta_propiedad: "nessuno ha quella struttura assegnata",
      nadie_trabaja_ese_dia: "nessuno lavora quel giorno",
      equipo_lleno: "la squadra è al limite",
    },
    rejected: {
      espacio_ajeno: "Quello spazio non è del tuo account.",
      persona_ajena: "Quella persona non è della tua squadra.",
      persona_sin_la_propiedad: "Quella persona non ha questa struttura assegnata. Assegnala prima in Squadra.",
      rol_desconocido: "Quel ruolo non esiste.",
      datos_incompletos: "Mancano dati della pulizia.",
      error_al_guardar: "Non è stato possibile salvare.",
    },
    autoAssignN: "Distribuisci {n}",
    seeDay: "Vedi la giornata",
    filtering: "Filtrando per",
    showingOf: "visti {n} di {total}",
    emptyFiltered: "Nessun risultato con questi filtri. Ci sono {total} pulizie in queste date.",
    moreFilters: "Altri filtri",
    roomy: "Comoda",
    dense: "Compatta",
    ofN: "su {n} pulizie",
    addPerson: "Aggiungi qualcuno alla squadra",
    notCleaner: "Non è personale di pulizia, ma ha lavoro assegnato",
    teamCap: "{n} al giorno",
    teamFoot: "Il carico è di tutto il periodo; i filtri non lo cambiano.",
    perDayN: "{n} al giorno",
    closedN: "{n} chiuse",
    capMax: "Il massimo sono {n} al giorno",
    rowHint: "Alt + clic per scegliere tutta la riga",
    daySheetTip: "Clicca per vedere la giornata · Alt + clic per sceglierla tutta",
    keysHint: "1-9 assegna · A apre · Esc pulisce",
    undo: "Annulla",
    undone: "Distribuzione ripristinata",
    tightDay: "{dia} ha {n} pulizie",
    tightMore1: "e 1 giorno in più",
    tightMoreN: "e altri {n} giorni",
    proposalDetail: "Vedi la distribuzione pulizia per pulizia",
    nobody2: "Ancora nessuno",
    warnDayOff: "{quien} è libero/a il {dia}.",
    warnOver: "{quien} arriva a {n} il {dia} e regge {cap}.",
    onDay: "{dia}: {n} + {mas} su {cap}",
    onDays: "{dias} giorni: {n} su {cap}",
    c: {
      pending: "In sospeso",
      urgent: "Urgenti",
      tight: "Giorni stretti",
      done: "Fatte",
      noRoom: "Senza camera",
    },
    rows: {
      withWork: "con lavoro",
      all: "tutti",
      help: "«Tutti» mostra anche gli spazi che in queste date non vanno puliti.",
      forced: "Con un filtro attivo si mostrano solo gli spazi che hanno lavoro.",
    },
    f: {
      any: "Qualsiasi",
      urgency: "Urgenza",
      window: "Finestra",
      state: "Stato",
      unitType: "Tipo di spazio",
      clear: "Pulisci filtri",
    },
    urg: {
      urgente: "Entra qualcuno quel giorno",
      alta: "Entra il giorno dopo",
      normal: "Entra tra 2-3 giorni",
      baja: "Non entra nessuno dopo",
    },
    holg: { amplia: "Ampia", justa: "Stretta", imposible: "Non c'è tempo" },
    estados: { pendiente: "In sospeso", en_curso: "In corso", hecha: "Fatta", fuera_de_servicio: "Fuori servizio" },
    motivos: {
      faltan_manos: "mancano braccia per {n}",
      con_hora_limite: "{n} con orario limite",
      varios_edificios: "{n} edifici diversi",
    },
    sheet: {
      autoDay: "Distribuisci questa giornata",
      assignAll: "Assegna tutte ({n})",
      nCleanings: "{n} pulizie",
      nUnassigned: "{n} non assegnate",
      covers: "la squadra copre {n}",
      empty: "Niente da pulire in questa giornata.",
    },
    tip: {
      outIn: "esce · entra",
      lateSold: "partenza posticipata venduta",
      earlySold: "arrivo anticipato",
      noName: "Senza nome",
      pax: "{n} pax",
      nights: "{n} notti",
      min: "{n} min",
      h: "{h} h",
      hm: "{h} h {m}",
      stillIn: "ancora alloggiato",
      freeNobody: "resta libero",
      freeNone: "entra un altro",
      freeDay1: "libero 1 giorno",
      freeDaysN: "libero {n} giorni",
      houseHours: "orari di default",
      openSpace: "Scheda dello spazio", openSpaceHint: "Si apre nella bacheca di Oggi, con stato, attività e storico",
      select: "Scegli",
      deselect: "Togli dalla selezione",
      assignedBy: "Assegnata da {quien}",
    },
  },
};
